import { render, staticRenderFns } from "./PazienteAllegatiEdit.vue?vue&type=template&id=2619a2ee"
import script from "./PazienteAllegatiEdit.vue?vue&type=script&lang=js"
export * from "./PazienteAllegatiEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports